import { useContext, useEffect } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { useUserId } from '~/context/common/UserContext';
import FinanceContext from '~/context/home/FinanceContext';
import { fetchCreditStatus } from '~/services/home';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetCreditStatus(shouldGetCreditStatus: boolean) {
  const {
    financeInfo: { setData, setError, setLoading },
    fetchFinanceTrigger
  } = useContext(FinanceContext);
  const userId = useUserId();
  const {
    activeTrade,
    trades: { isLoaded }
  } = useContext(TradeContext);

  const tradeEquity = activeTrade?.equity ?? 0;
  useEffect(() => {
    setLoading();
    if (!shouldGetCreditStatus) return setData({});
    if (!isLoaded) return;

    fetchCreditStatus({ userId, tradeEquity })
      .then(({ status, data }) => {
        if (status === 200) {
          setData(data);
        }
        // 204 is returned when the user has no credit status history and data is an empty string
        if (status === 204) {
          setData({});
        }
      })
      .catch(
        generateErrorLogger('Get finance info', {}, { callback: setError })
      );
  }, [
    fetchFinanceTrigger,
    isLoaded,
    setData,
    setError,
    setLoading,
    shouldGetCreditStatus,
    tradeEquity,
    userId
  ]);
}
